import { FunctionComponent } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { useTranslation } from 'react-i18next'
import { TablePagination } from 'components/TablePagination'
import { useBoolean } from 'hooks/useBoolean'
import { useQueryState } from 'react-router-use-location-state'
import { useFaqQuery } from 'services/info-center/faq'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { FaqCard } from './faq-card'
import { DialogCreateFaq } from './dialog-create-faq'

export const Faq: FunctionComponent = () => {
  const { t } = useTranslation()
  const dialogCreateFaq = useBoolean(false)

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
    keyword: '',
  } as const

  const { data: faqs, isError, isLoading } = useFaqQuery(args)

  if (isLoading) return <Loading />

  if (isError) return <Error />

  if (faqs === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      {dialogCreateFaq.isTrue && (
        <DialogCreateFaq onClose={dialogCreateFaq.setFalse} />
      )}
      <Box display="flex" justifyContent="space-between">
        <Typography fontWeight="bold" variant="h6">
          {t('faq')}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          onClick={dialogCreateFaq.setTrue}
        >
          {t('create')}
        </Button>
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {faqs.items.map((faq) => (
        <FaqCard key={faq.id} faq={faq} />
      ))}

      {faqs.info.totalRows !== 0 && (
        <TablePagination
          total={faqs.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PageWrapper>
  )
}
